import { createContext, useContext, type ReactNode } from 'react';

import type { GetReactionsQuery } from '#graphql/queries/reactions';

export type ReactionsContextValue = GetReactionsQuery['reactions'];

const ReactionsContext = createContext<ReactionsContextValue | undefined>(
  undefined,
);

interface ReactionsProviderProps {
  value: ReactionsContextValue;
  children: ReactNode;
}

export function ReactionsProvider({ value, children }: ReactionsProviderProps) {
  return (
    <ReactionsContext.Provider value={value}>
      {children}
    </ReactionsContext.Provider>
  );
}

export function useReactions(): ReactionsContextValue {
  const value = useContext(ReactionsContext);
  if (value === undefined) {
    throw new Error('useReactions must be used within ReactionsProvider');
  }
  return value;
}
